import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { SalesTaxNumberInput } from './SalesTaxNumberInput';

export function SalesTaxNumberField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={SalesTaxNumberInput}
      label='Vorname'
    />
  );
}
